module.exports = __webpack_public_path__ + "assets/taskmaster.png?ddffbd1807147bd851ffdd0324481b1f";